import { render, staticRenderFns } from "./PerfumeDetails.vue?vue&type=template&id=0bf02920&scoped=true"
import script from "./PerfumeDetails.vue?vue&type=script&lang=js"
export * from "./PerfumeDetails.vue?vue&type=script&lang=js"
import style0 from "./PerfumeDetails.vue?vue&type=style&index=0&id=0bf02920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf02920",
  null
  
)

export default component.exports